<script lang="ts">
  import { SearchClassificationGuidanceEntity } from "@shared/services/event_tracking/entities";
  import { EventTracking } from "@shared/services/event_tracking/events";
  import TrackedLink from "@shared/svelte/Components/Tracking/TrackedLink.svelte";
  import TrackingContext from "@shared/svelte/Components/Tracking/TrackingContext.svelte";

  import type { SearchClassification } from "@shared/types/SearchClassification";

  const { trackMrcEvents } = EventTracking;

  export let searchClassification: SearchClassification;
  export let searchQuery: string;

  const trackingParams: SearchClassificationGuidanceEntity =
    SearchClassificationGuidanceEntity.fromSearchClassificationAndQuery(
      searchClassification,
      searchQuery,
    );
</script>

<TrackingContext entities={trackingParams} let:trackingContext>
  <p data-testid="search-classification-guidance" use:trackMrcEvents={[trackingContext.entities]}>
    Displaying results for keyword <strong>{searchQuery}</strong>. Narrow results to
    <TrackedLink
      forwardLink={searchClassification.forward_url}
      targetObjectType={"search_classification_guidance_link"}
      linkText={`${searchClassification.name} in ${searchClassification.helper_text}?`}
    />
  </p>
</TrackingContext>
